import {useDispatch} from "react-redux";
import {ACTION_TYPES} from "store/ActionTypes";

export function useLoginPopup(): (b: boolean) => void {
  //
  const dispatch = useDispatch();
  const showLoginPopup = (show: boolean) => {
    dispatch({type: ACTION_TYPES.MAIN.SHOW_LOGIN_POPUP, payload: show});
  };
  return showLoginPopup;
}